import ar from './ar.json';
import en from './en.json';

/**
 * The Notifications module's catalogue, registered from `app.config.tsx` under
 * the `notifications` namespace — `shared/i18n` never imports a module (W2).
 *
 * The **category** labels are deliberately not here: they are in the shared
 * `common` catalogue, because the defaults grid and the mobile preferences
 * screen name the same eleven things (P17c's `stack-screen-keys` rule, one layer
 * over).
 */
export const notificationsCatalogs = { ar, en };
